import { useEffect, useRef } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function toWsUrl(path, token) {
  const url = new URL(BACKEND_URL);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  url.pathname = path;
  if (token) url.searchParams.set("token", token);
  return url.toString();
}

/** Subscribes to /api/ws/pub/<channel> ("__all__" for owner, needs token). Auto-reconnects. */
export function usePubSocket(pubId, onMessage, token) {
  const retryRef = useRef(0);
  const cbRef = useRef(onMessage);

  useEffect(() => {
    cbRef.current = onMessage;
  }, [onMessage]);

  useEffect(() => {
    if (!pubId) return;
    let closed = false;
    let timer = null;
    let ws = null;

    const connect = () => {
      if (closed) return;
      ws = new WebSocket(toWsUrl(`/api/ws/pub/${pubId}`, token));
      ws.onopen = () => {
        retryRef.current = 0;
      };
      ws.onmessage = (ev) => {
        try {
          const msg = JSON.parse(ev.data);
          if (msg?.type === "ping" || msg?.type === "connected") return;
          cbRef.current?.(msg);
        } catch {}
      };
      ws.onclose = () => {
        if (closed) return;
        const delay = Math.min(10000, 500 * 2 ** retryRef.current);
        retryRef.current += 1;
        timer = setTimeout(connect, delay);
      };
      ws.onerror = () => {
        try { ws.close(); } catch {}
      };
    };

    connect();
    return () => {
      closed = true;
      if (timer) clearTimeout(timer);
      try { ws?.close(); } catch {}
    };
  }, [pubId, token]);
}
